import React from 'react';
import hero from "../../assets/img/hero-home.svg"

const HeroSection = () => {
    return (
        <section className="ptb-100 overflow-hidden primary-bg">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between justify-content-md-center justify-content-sm-center">
                    <div className="col-md-12 col-lg-5">
                        <div className="hero-slider-content text-white py-5">
                            <div className="headline mb-4">
                                <p className="mb-0">
                                    <i className="fas fa-bell rounded-circle mr-2"></i>{' '}
                                    <span className="fw-bold">30% Discount</span> first annual purchase
                                </p>
                            </div>
                            <h1 className="text-white">Unlimited Domain & Hosting in One Platform</h1>
                            <p className="lead">
                                A ton of website hosting options, 99.9% uptime guarantee, free SSL certificate, easy WordPress installs.
                            </p>

                            <div className="action-btns mt-4">
                                <a href="#" className="btn btn-tertiary btn-lg">Get started now</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-lg-6">
                        <div className="img-wrap">
                            <img src={hero} alt="hosting" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
